import { errorLoading, loading, loaded, responseHandler, errorGetStatus,
	tokenInterceptor } from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

export const teamWS = (state = { team: [] }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.TEAM.SET_TEAM:
      return Object.assign({}, state, { team: action.datas })
    default:
      return state
  }
}

export const setTeam = (data) => {
  return {
    type: Constants.ActionsConstants.TEAM.SET_TEAM,
    datas: data,
  }
}

export function teamCalls (dispatch, user, member, appProfile) {
  /**
   * Get all team detail of the current user
   */
  function fetchTeam () {
    let entryPoint = Constants.UrlsConstants.teamEntryPoint
    let method = Constants.MethodsWSConstants.TEAM.FETCH_TEAM

    fetch(urlServer+entryPoint+method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      dispatch(setTeam(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function AddMember () {
    let entryPoint = Constants.UrlsConstants.teamEntryPoint
    let method = Constants.MethodsWSConstants.TEAM.ADD_MEMBER

    fetch(urlServer+entryPoint+method, {
      method: 'POST',
      body: JSON.stringify(member),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchTeam()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function RemoveMember () {
    let entryPoint = Constants.UrlsConstants.teamEntryPoint
    let method = Constants.MethodsWSConstants.TEAM.REMOVE_MEMBER

    // dispatch(loading(method))
    fetch(urlServer+entryPoint+method+'?email=' + encodeURIComponent(member.email), {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchTeam()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function UpdateMemberAppProfile () {
    dispatch(loading(''))
    let entryPoint = Constants.UrlsConstants.teamEntryPoint
    let method = Constants.MethodsWSConstants.TEAM.UPDATE_PROFILE
    fetch(urlServer+entryPoint+method, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(appProfile),
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(data => {
      fetchTeam()
      dispatch(loaded('Error.Croutons.saveSuccess'))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      } else {
        dispatch(errorLoading('Error.Croutons.saveError'))
      }
    })
  }

  return {
    fetchTeam,
    AddMember,
    RemoveMember,
    UpdateMemberAppProfile,
  }
}
